<div *ngIf="showSpinner" class="text-center my-3">
    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
